import { useState } from 'react'

import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover.tsx'

interface VideoItemProps {
  title: string
  image: string
  duration: string
  date: string
  onClick: () => void
}

export const VideoItem = ({
  image,
  title,
  duration,
  date,
  onClick,
}: VideoItemProps) => {
  const [openPopover, setOpenPopover] = useState(false)

  const handleOpenPopover = () => {
    setOpenPopover(true)
  }

  const handleClosePopover = () => {
    setOpenPopover(false)
  }

  return (
    <div
      onClick={onClick}
      className="bg-card rounded-lg border p-4 min-w-[232px] w-[232px] h-[239px] flex flex-col gap-4 cursor-pointer hover:border-primary-500/30 hover:bg-primary-500/5 transition-colors"
    >
      <img
        src={image}
        alt="video cover"
        className="w-[200px] h-[125px] object-cover rounded"
      />
      <div className="flex flex-col gap-2">
        <Popover
          open={openPopover}
          onOpenChange={setOpenPopover}
        >
          <PopoverTrigger
            onMouseEnter={handleOpenPopover}
            onMouseLeave={handleClosePopover}
            className="flex items-center justify-start focus-visible:outline-none"
          >
            <h5 className="text-title text-base text-start font-medium h-[38px] leading-[19px] line-clamp-2">
              {title}
            </h5>
          </PopoverTrigger>
          <PopoverContent
            align="center"
            onMouseEnter={handleOpenPopover}
            onMouseLeave={handleClosePopover}
            className="px-2 py-[3px] rounded border-none focus-visible:outline-none"
            side="top"
          >
            <h5 className="text-title text-xs font-medium leading-5">
              {title}
            </h5>
            <PopoverArrow
              height={6}
              className="fill-neutral-default"
            />
          </PopoverContent>
        </Popover>
        <div className="flex gap-2">
          <div className="text-secondary-300 font-medium text-xs leading-5">
            {duration}
          </div>
          <div className="h-[20px] border-l" />
          <div className="text-secondary-300 font-medium text-xs leading-5">
            {date}
          </div>
        </div>
      </div>
    </div>
  )
}
